import React, { useEffect } from "react";
import styles from "./_css/leadPage.module.css";
import { LeadGroupText } from "leads/components/LeadGroupText";
import { observer } from "mobx-react";
import { useParams } from "react-router";
import { leadsStore } from "leads/_store/leadsStore";
import { formatPhoneNumber } from "leads/utils/formationDuration";
import { useTranslation } from "react-i18next";
import { Loader } from "_common/loaders/Loader";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LanguageIcon from "@material-ui/icons/Language";
import HomeIcon from "@material-ui/icons/Home";
import MessageIcon from "@material-ui/icons/Message";
import BusinessIcon from "@material-ui/icons/Business";
import { Helmet } from "react-helmet-async";

const LeadPage = observer(() => {
    const { t } = useTranslation();
    const { page: leadId } = useParams<{ page: string }>();

    useEffect(() => {
        if (leadId) {
            leadsStore.fetchLeadById(leadId);
        }
    }, [leadId]);

    if (leadsStore.leadState.isLoading || !leadsStore.lead) {
        return <Loader />;
    }

    const lead = leadsStore.lead;

    return (
        <>
            <Helmet>
                <meta name="robots" content="NOINDEX,NOFOLLOW" />
            </Helmet>
            <div className={"flex flex_column flex-1 p_25 pt_0 mv_40 makeItAContainer"}>
                <div className={`${styles.card} ${styles.clientInfo}`}>
                    <div className={styles.cardHeader}>
                        <h3 className={styles.clientInfoTitle}>{t("lead.form.clientInformation")}</h3>
                    </div>

                    <div className={styles.infoGroup}>
                        <LeadGroupText
                            icon={<PersonIcon fontSize="small" />}
                            label={t("lead.form.fullName")}
                            text={lead.client.fullName}
                        />
                        <LeadGroupText
                            icon={<PhoneIcon fontSize="small" />}
                            label={t("lead.form.phoneNumber")}
                            text={formatPhoneNumber(lead.client.phone)}
                        />

                        <LeadGroupText
                            icon={<EmailIcon fontSize="small" />}
                            label={t("lead.form.email")}
                            text={lead.client.email}
                        />
                        <LeadGroupText
                            icon={<AccessTimeIcon fontSize="small" />}
                            label={t("lead.form.requestTime")}
                            text={new Date(lead.client.createdAt).toLocaleString()}
                        />
                        <LeadGroupText
                            icon={<LanguageIcon fontSize="small" />}
                            label={t("lead.form.preferredLanguage")}
                            text={t(`lang.${lead.client.preferredLanguage}`)}
                        />
                        <LeadGroupText
                            icon={<HomeIcon fontSize="small" />}
                            label={t("lead.form.propertyType")}
                            text={t(lead.client.propertyType)}
                        />
                        <LeadGroupText
                            icon={<BusinessIcon fontSize="small" />}
                            label={t("lead.form.nameProperty")}
                            text={lead.client.nameProperty}
                        />
                        {lead.client.unitType && (
                            <LeadGroupText label={t("lead.form.unitType")} text={lead.client.unitType} />
                        )}
                        {lead.client.nameUnit && lead.client.nameUnit !== "" && (
                            <LeadGroupText label={t("lead.form.nameUnit")} text={lead.client.nameUnit} />
                        )}

                        <div className={`${styles.group} ${styles.fullWidth}`}>
                            <div className={styles.labelRow}>
                                <span className={styles.icon}>
                                    <MessageIcon fontSize="small" />
                                </span>
                                <label className={styles.label}>{t("lead.form.requestMessage")}</label>
                            </div>
                            <div className={`${styles.textarea} ${styles.readonlyText}`}>{lead.client.message}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default LeadPage;
